var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline" } },
    [
      _c(
        "el-select",
        {
          attrs: {
            "remote-method": _vm.fetchSupply,
            placeholder: "商家",
            remote: "",
            filterable: ""
          },
          on: { change: _vm.change },
          model: {
            value: _vm.supply_id,
            callback: function($$v) {
              _vm.supply_id = $$v
            },
            expression: "supply_id"
          }
        },
        [
          _c("el-option", { attrs: { value: "0", label: "全部" } }),
          _vm._v(" "),
          _vm._l(_vm.supply_options, function(item) {
            return _c("el-option", {
              key: item.supply_id,
              attrs: { value: item.supply_id, label: item.supply_name }
            })
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6585e54a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6585e54a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supplySelect.vue
// module id = null
// module chunks = 